export default theme => ({
  title: {
    marginBottom: theme.spacing.unit,
  },
  searchBar: {
    marginLeft: theme.spacing.unit * 13,
  },
})
